import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, useEffect, useState, useTransition, } from 'react';
import { contract } from '@aviv_price-pages/brand';
import { useThorEvent } from '@aviv-dxp/react-thor';
import { Box } from '@gemini/core';
import { usePageLayoutContext } from '@/hooks/usePageLayoutContext/usePageLayoutContext';
import { Logger } from '@/logger';
export const AgencyCardSidePanel = () => {
    const { microFrontends } = contract;
    const { pricePageProps: { pricePageContext }, } = usePageLayoutContext();
    const [AcDataProvider, setAcDataProvider] = useState(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [AcSidePanel, setAcSidePanel] = useState(null);
    const [isPending, startTransition] = useTransition();
    const [isMfeLoaded, setIsMfeLoaded] = useState(false);
    const agencyCardViewListEvent = useThorEvent({
        eventData: {
            event: 'view_item_list',
            av_category: '',
            av_items: [],
        },
    });
    const lazyLoadComponent = (componentName) => {
        return lazy(async () => {
            try {
                const module = await import('mfe_avis_pricePagesAgencyCards');
                return { default: module[componentName] };
            }
            catch (error) {
                Logger.error(error);
                return { default: () => '' };
            }
        });
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            startTransition(() => {
                setAcDataProvider(lazyLoadComponent('DataProvider'));
                setAcSidePanel(lazyLoadComponent('SidePanel'));
            });
        }
    }, []);
    useEffect(() => {
        if (AcDataProvider && AcSidePanel) {
            setIsMfeLoaded(true);
        }
    }, [AcDataProvider, AcSidePanel]);
    useEffect(() => {
        if (!isMfeLoaded)
            return;
        // Currently the AC SidePanel will send the view_item_list event every time
        // we resize from desktop to mobile due to re-render. This is a workaround
        // with sessionStorage so that it only fires once per geolocation.
        const hasFiredInitialTracking = sessionStorage.getItem('hasFiredSidePanelAgencyCardViewItemListTracking');
        const onAnalytics = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        event) => {
            const { detail } = event;
            if (!detail)
                return;
            const eventProps = {
                ...detail,
                av_geolocation_level: pricePageContext.place.type,
                av_category: 'price_map',
            };
            if (hasFiredInitialTracking && eventProps.event === 'view_item_list') {
                return;
            }
            agencyCardViewListEvent({
                eventData: {
                    ...eventProps,
                },
            });
            sessionStorage.setItem('hasFiredSidePanelAgencyCardViewItemListTracking', 'true');
        };
        const agencyCardComponent = document.getElementById('agencyCard-container');
        agencyCardComponent?.addEventListener('agencyCard:onAnalytics', onAnalytics);
        return () => {
            agencyCardComponent?.removeEventListener('agencyCard:onAnalytics', onAnalytics);
        };
    }, [isMfeLoaded, pricePageContext.place.type, agencyCardViewListEvent]);
    if (!microFrontends?.mfe_avis_pricePagesAgencyCards) {
        return;
    }
    return isPending || !AcDataProvider || !AcSidePanel ? (_jsx("div", { children: "Loading..." })) : (_jsx(Box, { marginTop: "spacing.48", paddingTop: "0", id: "agencyCard-container", children: _jsx(AcDataProvider, { postalCode: pricePageContext.place.postalCode, children: _jsx(AcSidePanel, {}) }) }));
};
